import React ,{useState , useEffect} from "react";
import { CommonCharts } from "../CommonCharts/CommonCharts";
import Commonrecords from "../Commonrecords/Commonrecords";
import { useDispatch, useSelector } from "react-redux";
import {clearCustomerSupportClientList ,clearCustomerSupportClientChart } from "../../../../../../../../Redux/Slice"


export default function Clientcontaintabs({
      datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range

}) {
    const dashboardData = useSelector((state) => state.CustomerSupportClientList.CustomerSupportClientListData);
    const ChartResponse_API = useSelector((state) => state.CustomerSupportClientChart.CustomerSupportClientChartData);
    const state = useSelector((state) => state);
     const dispatch = useDispatch();
  const [search, setSearch] = useState("");
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");




  useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                region: datas.region,
                zone: datas.zone,
                state:datas.state,
                client:Client,
                               search:search,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
date:date,
            
            }
         dispatch(clearCustomerSupportClientList(payload))
    }
    },[datas  ,Client  ,PriorityValues , date ,search ,range])


   useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                region: datas.region,
                zone: datas.zone,
                state:datas.state,
                client:Client,
                                       date:date,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
              date:date,
              }
         dispatch(clearCustomerSupportClientChart(payload))
    }
    },[datas  ,Client  ,PriorityValues ,date ,range ])



const Allissues = dashboardData.map((item) => ({
  id: item.client_id__id,
  name: item.client_id__client_name,
  count: item.group_tickets,
}));


const ChartResponse = ChartResponse_API.map(item => ({
value: item.ticket_percentage != null
  ? parseFloat(item.ticket_percentage.toFixed(2))
  : 0,
  name: item.client_id__client_name.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) // Proper Case
}));

  return (
    <div className="chart-list-row_state">

  <div className="Chart_design">

        <CommonCharts title="Top 5 Issue Client" data={ChartResponse} />
  </div>

<div className="Listed_datas">

  <Commonrecords allIssues={Allissues}  title={"Clients List"} 
    search={search} setSearch={setSearch}
    

  />

</div>
    </div>
  );
}
